<script lang="ts" setup>
interface AppListPaginationFooterProps {
    label: string;
    options: number[];
    show: number;
    page: number;
    total: number;
    hideTotals?: boolean;
    centered?: boolean;
}

const props = defineProps<AppListPaginationFooterProps>();

const emit = defineEmits<{
    (e: "update:show", v: number): void;
    (e: "update:page", v: number): void;
}>();

const perPageOptions = computed(() =>
    props.options.map((option) => ({
        label: props.label ? `${option} ${props.label}` : option,
        value: option,
    })),
);

const perPage = computed({
    get: () => perPageOptions.value.find(({ value }) => value === props.show),
    set: ({ value }) => emit("update:show", value),
});

const showing = computed(() => {
    const show = props.show * props.page;

    return {
        from: props.page === 1 ? 1 : (props.page - 1) * props.show + 1,
        to: show > props.total ? props.total : show,
    };
});
</script>

<template>
    <div v-if="perPageOptions.length" class="flex items-center gap-1.5">
        Show:
        <USelectMenu v-model="perPage" :options="perPageOptions" />
    </div>
    <div
        :class="{
            'justify-center': centered,
        }"
        class="flex items-center gap-4"
    >
        <span v-if="total && !hideTotals"
            ><span class="font-medium">{{ showing.from }}</span
            >-<span class="font-medium">{{ showing.to }}</span> of
            <span class="font-medium">{{ total }}</span> {{ label }}</span
        >
        <UPagination
            v-if="total > show"
            :model-value="page"
            :next-button="{
                icon: 'i-heroicons-arrow-small-right',
                trailing: true,
                label: 'Next',
            }"
            :page-count="show"
            :prev-button="{
                icon: 'i-heroicons-arrow-small-left',
                label: 'Previous',
            }"
            :total="total"
            size="md"
            @update:model-value="emit('update:page', $event)"
        />
    </div>
</template>
